import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'regenerator-runtime/runtime';
import './index.css';
import App from './app';

ReactDOM.render(<App />, document.getElementById('root'));
